import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./style.css";
import AppFloatingLableInput from "../AppFloatingLableInput";
import {
  PhoneIcon,
  TickIcon,
  UserIcon,
} from "../../../assets/icons/newicon/icon";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../../firebase";

const ContactInfomationCard = ({
  customerName,
  customerPhone,
  payDetails,
  setPayDetails,
}) => {
  const handleNameChange = (e) => {
    let val = e.target.value
    if (val.length == 1) logEvent(analytics, "pl_name");
    setPayDetails({ ...payDetails, customer_name: val });
  };

  const handleNumberChange = (e) => {
    let val = e.target.value
    if (val.length == 11) logEvent(analytics, "pl_phone_number");
    setPayDetails({ ...payDetails, customer_phone: val?.replace(/\D/g, "") });
  };

  return (
    <div className="contactInfoWrapper">
      <Container>
        <Row>
          <Col>
            <div className="contactInfoInnerWrapper">
              <h2 className="fontSize14 fontWeight700 darkGrayColor marBot15">
                Contact information
              </h2>

              <AppFloatingLableInput
                data={{
                  title: "Name",
                  maxLength: 80,
                  value: customerName, // Controlled value
                  onChange: handleNameChange, // Update parent state
                  prefixIcon: customerName ? <TickIcon /> : <UserIcon />,
                  disabled: !payDetails?.nameEdit,
                }}
              />
              <AppFloatingLableInput
                data={{
                  title: "Phone number",
                  maxLength: 11,
                  value: customerPhone, // Controlled value
                  onChange: handleNumberChange, // Update parent state
                  prefixIcon: customerPhone ? <TickIcon /> : <PhoneIcon />,
                  disabled: !payDetails?.phoneEdit,
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactInfomationCard;
